<template>
    <div>
        <div class="flex between">
            <el-form :model="po" ref="poRef" label-width="80px" inline>
                <el-form-item label="省份">
                    <el-select v-model="po.provinceId" clearable placeholder="请选择省" @change="handleProvince">
                        <el-option
                            v-for="item in po.provinceLists"
                            :key="item.region_id"
                            :label="item.region_name"
                            :value="item.region_id"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="城市">
                    <el-select v-model="po.cityId" clearable placeholder="请选择城市" @change="handleCity">
                        <el-option
                            v-for="item in po.cityLists"
                            :key="item.region_id"
                            :label="item.region_name"
                            :value="item.region_id"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="区">
                    <el-select v-model="po.districtId" clearable placeholder="请选择区">
                        <el-option
                            v-for="item in po.districtLists"
                            :key="item.region_id"
                            :label="item.region_name"
                            :value="item.region_id"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="是否vip">
                    <el-select v-model="po.isVip" clearable placeholder="请选择">
                        <el-option
                            v-for="item in po.vipOpts"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label-width="15px">
                    <el-button @click="resetHandler">重置</el-button>
                    <el-button type="primary" @click="searchHandler">查询</el-button>
                </el-form-item>
            </el-form>
            <div class="table-opt">
                <el-button @click="addHandler">新增</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <el-table :data="vo.tableList" style="width: 100%" v-loading="vo.loading">
            <el-table-column label="公司名" prop="company_name"> </el-table-column>
            <el-table-column prop="contactor" label="联系人"> </el-table-column>
            <el-table-column prop="phone" label="联系电话"> </el-table-column>
            <el-table-column prop="address" label="详细地址" width="300px">
                <template #default="{ row }">
                    {{ row.province }} {{ row.city }} {{ row.district }} {{ row.address }}
                </template>
            </el-table-column>
            <el-table-column prop="addre" label="经纬度">
                <template #default="{ row }"> {{ row.lng }} - {{ row.lat }} </template>
            </el-table-column>
            <el-table-column prop="addre" label="VIP">
                <template #default="{ row }"> {{ row.isVip === 1 ? '是' : '否' }}</template>
            </el-table-column>
            <el-table-column prop="" label="状态" width="70">
                <template #default="{ row }">
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        :content="row.reason"
                        :disabled="row.status !== 2"
                        placement="left"
                    >
                        <el-tag :type="row.status === 0 ? 'info' : row.status === 1 ? 'success' : 'danger'">
                            {{ getStatusLabel(row.status) }}
                        </el-tag>
                    </el-tooltip>
                </template></el-table-column
            >
            <el-table-column prop="reason" label="拒绝理由">
                <template #default="{ row }"> {{ row.reason || row.reason !== null ? row.reason : '' }}</template>
            </el-table-column>

            <el-table-column label="操作" width="300" class-name="deal-column">
                <template #default="{ row }">
                    <el-button text type="primary" v-if="row.status === 0" @click="handleStatus(row, 1)">
                        审核通过
                    </el-button>
                    <el-button text type="primary" v-if="row.status === 0" @click="handleStatus(row, 2)">
                        拒绝
                    </el-button>
                    <el-button text type="primary" @click="editClick(row)">编辑</el-button>
                    <el-button text type="primary" @click="deleteClick(row)"> 删除 </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-style">
            <el-pagination
                background
                layout="prev, pager, sizes, next"
                :total="vo.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
        </div>
        <FormDialog
            :visible="dialogVisible"
            @parentCallback="parentCallback"
            @closeDialog="handleCloseDialog"
            :saleId="po.targetArticleId"
            v-if="dialogVisible"
        />
    </div>
</template>
<script setup>
import { ElMessage, ElMessageBox } from 'element-plus';
import request from '@/request/index';
import { reactive, ref } from 'vue';
import FormDialog from './form/index.vue';
const po = reactive({
    pid: '',
    cid: '',
    vipOpts: [
        {
            value: 0,
            name: '否'
        },
        {
            value: 1,
            name: '是'
        }
    ],
    isVip: '',
    districtLists: [],
    provinceLists: [],
    cityLists: [],
    districtId: '',
    cityId: '',
    provinceId: '',
    pageSize: 10,
    pageNum: 1,
    targetArticleId: 0
});
const vo = reactive({ tableList: [], loading: true, total: 0 });
const dialogVisible = ref(false);
const getStatusLabel = status => {
    return status === 0 ? '未审核' : status === 1 ? '已通过' : '已拒绝';
};
// 根据应用查询角色级联信息
const queryInitHandler = async function () {
    vo.loading = true;
    const result = await request('querySaleNetLists', {
        provinceId: po.provinceId,
        cityId: po.cityId,
        districtId: po.districtId,
        isVip: po.isVip,
        page: po.pageNum,
        perPage: po.pageSize
    });
    const list = result.data.list;
    if (result.data.totalCount === 0) {
        vo.tableList = [];
    } else {
        vo.tableList = list;
    }
    vo.total = result.data.totalCount;
    vo.loading = false;
};
queryInitHandler();

const handleSizeChange = function (e) {
    po.pageSize = e;
    po.pageNum = 1;
    queryInitHandler();
};
const handleCurrentChange = function (e) {
    po.pageNum = e;
    queryInitHandler();
};
const poRef = ref(null);
const resetHandler = function () {
    po.cityId = '';
    po.districtId = '';
    po.provinceId = '';
    po.isVip = '';
    poRef.value.resetFields();
    queryInitHandler();
};
const searchHandler = function () {
    po.pageNum = 1;
    queryInitHandler();
};
const openDialog = () => {
    dialogVisible.value = true;
};
const addHandler = () => {
    po.targetArticleId = 0;
    openDialog();
};
const handleCloseDialog = () => {
    dialogVisible.value = false;
};

const handleStatus = (row, status) => {
    if (status === 2) {
        ElMessageBox.prompt('拒绝理由', '提示', {
            confirmButtonText: '提交',
            cancelButtonText: '取消',
            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
            inputErrorMessage: '请输入拒绝理由'
        }).then(async ({ value }) => {
            if (!value) {
                ElMessage({
                    type: 'error',
                    message: `请输入拒绝理由`
                });
                return;
            }
            const result = await request('updateSaleNetStatus', {
                id: row.id,
                reason: value,
                status: 2
            });
            if (result.status === 200) {
                ElMessage({
                    message: result.msg,
                    type: 'success'
                });
                queryInitHandler();
            }
        });
    } else {
        ElMessageBox.confirm('确认执行此操作吗', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
        })
            .then(async () => {
                const result = await request('updateSaleNetStatus', {
                    id: row.id,
                    status: 1
                });
                if (result.status === 200) {
                    ElMessage({
                        message: result.msg,
                        type: 'success'
                    });
                    queryInitHandler();
                }
            })
            .catch(() => {
                console.log('cancel');
            });
    }
};
const deleteClick = row => {
    ElMessageBox.confirm('确认要删除此配置吗', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            const result = await request('deleteSaleNet', {
                id: row.id
            });
            if (result.status === 200) {
                ElMessage({
                    message: result.msg,
                    type: 'success'
                });
                queryInitHandler();
            }
        })
        .catch(() => {
            console.log('cancel');
        });
};
const editClick = article => {
    po.targetArticleId = article.id;
    openDialog();
};
const parentCallback = function () {
    handleCloseDialog();
    queryInitHandler();
};

const handleProvince = () => {
    po.cityLists = [];
    po.cityId = '';
    po.districtId = '';
    fetchAreaLists(po.provinceId, 'c');
};
const handleCity = () => {
    po.districtId = '';
    po.districtLists = [];
    fetchAreaLists(po.cityId, 'd');
};
const fetchAreaLists = async (pid, type) => {
    const rsp = await request('areaLists', { parent_id: pid });
    if (rsp.status === 200) {
        const dataLists = rsp.data.list;
        if (type === 'p') {
            po.provinceLists = dataLists;
        } else if (type === 'c') {
            po.cityLists = dataLists;
        } else if (type === 'd') {
            po.districtLists = dataLists;
        }
    }
};
fetchAreaLists(1, 'p');
</script>
